/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { JsonPatchOperationType } from "./JsonPatchOperationType";
export const JsonPatchOperation = core.serialization.object({
    op: JsonPatchOperationType,
    from: core.serialization.string().optional(),
    path: core.serialization.string().optional(),
    value: core.serialization.any().optional(),
});
